<template>
    <AppTabLinks :links="list" />
</template>

<script>
    import AppTabLinks from '@/components/AppTabLinks';

    export default {
        components: {
            AppTabLinks,
        },

        data() {
            return {
                isAuthorized: false,
                list: [
                    {
                        title: 'Карточка',
                        url: `/assistants/${this.$route.params.id}`,
                    },
                    {
                        title: 'Редактировать',
                        url: `/assistants/${this.$route.params.id}/edit`,
                    },
                    {
                        title: 'Описание',
                        url: `/assistants/${this.$route.params.id}/description`,
                    },
                    {
                        title: 'Услуги',
                        url: `/assistants/${this.$route.params.id}/service`,
                    },
                    {
                        title: 'Категории',
                        url: `/assistants/${this.$route.params.id}/categories`,
                    },
                    {
                        title: 'Варианты',
                        url: `/assistants/${this.$route.params.id}/options`,
                    },
                    {
                        title: 'Дополнительно',
                        url: `/assistants/${this.$route.params.id}/extras`,
                    },
                    {
                        title: 'Акции',
                        url: `/assistants/${this.$route.params.id}/promotions`,
                    },
                ],
            };
        },
    };
</script>
